import {t} from "../../i18n";
import {bindInputListeners, bindPhoneValidation, showValidationErrors, reportRequestError, hasFieldErrors} from "../../utils/formHelpers";
import {logClientEvent} from "../../utils/jsErrorLogger.js";
import {renderCountrySelect, pickDefaultCountry, bindCountryPicker} from "../../utils/phoneCountries.js";
import {showBlockedNotice} from "../../utils/blockedNotice.js";

// Cat asteptam raspunsul la „e blocat?”: peste atat mergem mai departe ca pana acum (Finalize
// ramane plasa), nu tinem omul pe un buton care nu raspunde.
const CHECK_BLOCKED_TIMEOUT_MS = 8000;

export default function bookingPhone({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render() {
        // Re-auth de la Finalize (sesiunea a murit): omul ARE telefon verificat, deci nu-i spunem
        // că „contul nu are încă telefon verificat” (requestPhoneCheckDetails). Cheie lipsă pe server
        // → t() întoarce cheia brută → nu afișăm nimic în loc de cheie.
        const reauthText = data.reauth ? t('booking_reauth_phone_details') : '';
        // Just registered (not logged in until the code comes back) reads like a logged-in account.
        const isAccount = !!data.isAuth || !!sharedState.registeredId;
        const panelTitle = data.reauth ? t('confirmPhoneTitle') : t(isAccount ? 'requestPhoneCheckTitle' : 'requestPhoneNoAccTitle');
        const panelDetails = data.reauth
            ? (reauthText === 'booking_reauth_phone_details' ? '' : reauthText)
            : t(isAccount ? 'requestPhoneCheckDetails' : 'requestPhoneNoAccDetails');
        const backButton = data.skipUser ? '' : `<button class="modal-close-button auth-back-btn" data-step="booking-init">X</button>`;
        // The name is read only on the guest branch (noAccount) below. Account holders -- logged in,
        // or just registered and not yet logged in (SMS step close button lands here) -- already
        // have a name; showing the field there only collected input nobody read.
        const showName = !!sharedState.noAccount && !data.isAuth;
        // Why the number matters depends on what happens next: only the guest branch on an account
        // without SMS skips the code (see proceed()); there a wrong number reaches the salon as a
        // request nobody can confirm. Everywhere else a code is sent to it.
        const invalidPhoneText = t(sharedState.noAccount && data.skipValidate ? 'phone_invalid_no_sms' : 'phone_invalid_sms');
        let validatePhone = () => true; // set by bindPhoneValidation below
        const $el = $(`
    <div class="booking-step-row active" data-auth-step="booking-phone">
        ${backButton}
        <div class="texts-phone-check-header" >
            <h3 class="text-center">${panelTitle}</h3>
            <p>${panelDetails}</p>
        </div>
        <form class="booking-phone-form">
            <div class="form-row booking-name-input"${showName ? '' : ' style="display: none"'}>
                <label for="bookingName">${t('full_name')}</label>
                <input type="text" id="bookingName">
                <p class="field-error field-name-error" style="display:none;">
                    ${t('please_enter_a_name')}
                </p>
            </div>
            <div class="form-row">
                <label for="bookingPhone">${t('phone')}</label>
                <div class="phone-row">
                    ${renderCountrySelect({id: 'bookingPhoneCountry', selected: pickDefaultCountry(data, sharedState)})}
                    <input type="tel" inputmode="tel" autocomplete="tel"
                        required="" id="bookingPhone" name="phone" value="${sharedState.phone || ''}">
                </div>
                <p class="field-error field-phone-incorrect-error" style="display:none;">
                    ${t('form.phone_number_not_found')}
                </p>
                <p class="field-error field-phone-ro-error" style="display:none;">
                    ${t('form.please_enter_a_valid_number')}
                </p>
                <p class="field-error field-phone-invalid-error" style="display:none;">
                    ${invalidPhoneText}
                </p>
            </div>
            <div class="form-actions">
                <button type="submit">${data.skipValidate ? t('continue') : t('send_sms')}</button>
            </div>
        </form>
    </div>
        `);

        $el.on('submit', '.booking-phone-form', e => {
            e.preventDefault();

            let phone = $("#bookingPhone").val().trim();
            phone = phone.replace(/[^\d+]/g, '');
            // The picker: parse country for a prefix-less number, sent with every code request of this
            // widget (App\Support\Phone::COUNTRY_FIELD). A typed "+36..." wins over it server-side.
            const phoneCountry = $el.find('#bookingPhoneCountry').val();
            sharedState.phoneCountry = phoneCountry;
            let bookingName = '';

            if(sharedState.noAccount) {
                const $nameInput = $('#bookingName');
                bookingName = $nameInput.val().trim();

                // If the input is visible and empty, show error and abort submission
                if ($nameInput.is(':visible')) {
                    const $nameError = $el.find('.field-name-error');
                    const minNameLength = 3;
                    if (!bookingName || bookingName.length < minNameLength) {
                        if(bookingName && bookingName.length < minNameLength) {
                            $nameError.text(t('please_enter_a_valid_name_min_chars', {count: minNameLength}));
                        }
                        $nameError.show();
                        $nameInput.addClass('input-error');
                        return;
                    } else {
                        $nameError.hide();
                        $nameInput.removeClass('input-error');
                    }
                }

                // Pe ecranul de re-auth inputul de nume e ascuns (isAuth) și gol: nu ștergem numele
                // deja cunoscut, altfel rândul ajungea în agendă ca „Fara cont”.
                if (bookingName || !state.bookingName) {
                    state.bookingName = bookingName;
                }
            }

            // Enter in the field submits even while the button is disabled, and a prefilled number
            // was never typed: judge it here too. The server refuses the same numbers.
            if (!validatePhone(true)) {
                return;
            }

            // BLOCAT LA PROGRAMARI ONLINE (2.0.7): intrebam serverul AICI, inainte de cod si de
            // onComplete - pe orice cont. Pe conturile fara SMS (skipValidate) altfel serverul vedea
            // telefonul abia la Finalize, dupa tot formularul. Blocat -> pasul e inlocuit de mesaj.
            checkBlocked(phone, phoneCountry, () => proceed());

            function proceed() {
            if(sharedState.noAccount) {
                if(data.skipValidate) {
                    // Validation disabled at the account level — finish auth
                    // immediately. MUST `return` so we don't fall through to
                    // the unconditional onNext('booking-sms') below, which
                    // would otherwise render the SMS-code entry screen on
                    // top of the just-completed flow (the original bug:
                    // skip_validate=Y was ignored visually because the
                    // navigation still happened).
                    sharedState.phone = phone;
                    onComplete({user: {name: bookingName, phone: phone}});
                    return;
                } else {
                    getCode($el, routes.generateCode, { phone, phone_country: phoneCountry });
                }
            } else {
                // NOT the guest branch: this is a logged-in web user whose phone
                // is not validated yet. skipValidate deliberately does NOT apply
                // -- it protects the unregistered path only, and a web-user phone
                // has to be real because one web user books across many
                // businesses. The server always sends here (forWebUserValidation)
                // and absorbs the cost when the account cannot pay.
                let email = sharedState.email;
                getCode($el, routes.validatePhone, { phone, email, phone_country: phoneCountry });
            }

            // NB: navigation happens in getCode()'s success handler, never here.
            // It used to fire unconditionally at this point, so a failed or
            // refused request still rendered the code-entry screen and the
            // client sat waiting for an SMS that was never sent.
            sharedState.phone = phone;
            }
        });

        /**
         * „E blocat la salonul asta?” (AppointmentController::checkBlocked). Blocat -> antetul si
         * formularul pasului sunt inlocuite de mesaj (butonul de inchidere ramane) si nu se mai merge
         * inainte. Orice altceva - ruta lipsa pe o pagina randata inainte de ea, retea, 5xx, timeout -
         * merge mai departe ca pana acum: AppointmentController::store refuza oricum la Finalize.
         */
        let checking = false;
        function checkBlocked(phone, phoneCountry, then) {
            if (!routes.checkBlocked) {
                then();
                return;
            }
            if (checking) {
                return; // dublu-click: prima intrebare decide
            }
            checking = true;
            const $btn = $el.find('button[type="submit"]');
            $btn.prop('disabled', true);
            const done = () => {
                checking = false;
                $btn.prop('disabled', false);
            };
            api.post(routes.checkBlocked, {
                data: {phone, phone_country: phoneCountry},
                timeoutMs: CHECK_BLOCKED_TIMEOUT_MS,
                success: (res) => {
                    done();
                    if (res && res.blocked) {
                        showBlockedNotice($, $el, $el.find('.texts-phone-check-header, .booking-phone-form'), res.message);
                        return;
                    }
                    then();
                },
                error: () => {
                    done();
                    then();
                }
            });
        }

        bindInputListeners($el);

        const $phoneInput = $el.find('input[name="phone"]');
        const $phoneCountry = $el.find('#bookingPhoneCountry');

        // bindCountryPicker first: its select change (flag) must not depend on the order of handlers.
        bindCountryPicker($phoneInput, $phoneCountry);
        validatePhone = bindPhoneValidation($phoneInput, {
            withCountryPicker: true,
            $country: $phoneCountry,
            onValidChange: (isValid) => {
                $el.find('button[type="submit"]').prop('disabled', !isValid);
            }
        });

        return $el;
    }

    /**
     * @param {boolean} viaGuest  al doilea drum, luat automat după un 404 pe validatePhone:
     *   pagina se crede logată (login Google prin popup: popup-ul face login-ul în sesiunea LUI
     *   și anunță pagina prin postMessage), dar serverul n-are sesiunea pe cererile paginii —
     *   Chrome pe iOS, houseofart 9 sept 2026. Codul pleacă atunci pe ruta de oaspete
     *   (generateCode), care nu cere sesiune. Restul lanțului merge la fel: verificarea codului
     *   caută după telefon + cod, iar Finalize acceptă rezervarea „logat fără sesiune” ca oaspete
     *   cu telefon (garda din AppointmentController::store, august 2026).
     */
    function getCode($el, url, param, viaGuest = false) {
        api.post(url, {
            data: param,
            success: (res) => {
                if (res && res.skipValidate) {
                    // Server refused to send: validation is not on offer for this
                    // account (smsGroup opted out, or credit ran out since the page
                    // was rendered, so the flag we were handed is stale). Nothing
                    // was sent, so do not show a code screen.
                    if (data.reauth && data.reauthReason === 'login_required'
                        && !sharedState.noAccount && !data.skipUser) {
                        // Re-auth pentru reprogramare / abonament pe un cont fără SMS: n-a plecat niciun
                        // cod, deci login-ul nu se poate restaura prin SMS, iar retrimiterea ar lua sigur
                        // iar login_required. Singurul drum util e login-ul (emailul e precompletat).
                        onNext('booking-init');
                        return;
                    }
                    onComplete({user: res.user});
                    return;
                }
                if (viaGuest) {
                    sharedState.codeViaGuest = true; // „retrimite” din pasul SMS ia același drum
                }
                onNext('booking-sms');
            },
            error: (err) => {
                if (err?.status === 429) {
                    // AuthLimiter: bugetul de SMS (telefon / IP / cont) e epuizat → {errors: {phone: [msg]}}.
                    // Mesaj pe câmpul de telefon și STOP: NU e 404-ul care duce pe ruta de oaspete —
                    // a doua rută n-ar face decât să mai ardă o dată același buget.
                    showThrottled($el, err);
                    return;
                }
                if (err?.status === 404 && url === routes.validatePhone && !viaGuest) {
                    logClientEvent({message: 'validatePhone 404 -> guest code fallback', status: 404, step: 'phone'});
                    getCode($el, routes.generateCode, {phone: param.phone, phone_country: param.phone_country}, true);
                    return;
                }
                if (err?.status === 404) {
                    // Și drumul de oaspete a dat 404 (rută lipsă / pagină chiar expirată):
                    // mesaj pe câmpul de telefon, ca să nu fie mut (familia 419-ului de la Finalize).
                    logClientEvent({message: 'auth request failed', status: 404, step: 'phone'});
                    showValidationErrors($el, {phone: t('booking_session_expired')});
                    return;
                }
                reportRequestError($el, err, 'phone');
            }
        })
    }

    /** 429 pe câmpul de telefon: textul serverului când există, altfel mesajul generic de plafon. */
    function showThrottled($el, err) {
        const errors = hasFieldErrors(err) ? err.data.errors : null;
        let first = null;
        if (Array.isArray(errors)) {
            first = errors[0];
        } else if (errors) {
            first = errors.phone || Object.values(errors)[0];
        }
        const text = Array.isArray(first) ? first[0] : first;
        const fallback = t('too_many_requests');
        showValidationErrors($el, {
            phone: (typeof text === 'string' && text)
                ? text
                : (fallback === 'too_many_requests' ? t('auth_error_generic') : fallback)
        });
    }

    return { render }
}